import {TeamEvent} from './TeamEvent';

export class TeamCreated extends TeamEvent {}
